export interface StateDefinition {
  name: string;
  code: string;
  pattern: string;
  tooltip: string;
  errorMessage?: string;
}

export const Static_States: StateDefinition[] = [
  {
    name: "Alabama",
    code: "AL",
    pattern: "^[0-9]{7,8}$",
    tooltip: "7-8 numbers"
  },
  {
    name: "Alaska",
    code: "AK",
    pattern: "^[0-9]{1,7}$",
    tooltip: "1-7 numbers"
  },
  {
    name: "Arizona",
    code: "AZ",
    pattern: "(^[A-Za-z]{1}[0-9]{1,8}$)|(^[A-Za-z]{2}[0-9]{2,5}$)|(^[0-9]{9}$)",
    tooltip: "1 letter + 1-8 numbers, or 2 letters + 2-5 numbers, or 9 numbers"
  },
  {
    name: "Arkansas",
    code: "AR",
    pattern: "^[0-9]{4,9}$",
    tooltip: "4-9 numbers"
  },
  {
    name: "California",
    code: "CA",
    pattern: "^[A-Za-z]{1}[0-9]{7}$",
    tooltip: "1 letter + 7 numbers"
  },
  {
    name: "Colorado",
    code: "CO",
    pattern: "(^[0-9]{9}$)|(^[A-Za-z]{1}[0-9]{3,6}$)|(^[A-Za-z]{2}[0-9]{2,5}$)",
    tooltip: "9 numbers, or 1 letter + 3-6 numbers, or 2 letters + 2-5 numbers"
  },
  {
    name: "Connecticut",
    code: "CT",
    pattern: "^[0-9]{9}$",
    tooltip: "9 numbers"
  },
  {
    name: "Delaware",
    code: "DE",
    pattern: "^[0-9]{1,7}$",
    tooltip: "1-7 numbers"
  },
  {
    name: "District of Columbia",
    code: "DC",
    pattern: "(^[0-9]{7}$)|(^[0-9]{9}$)",
    tooltip: "7 or 9 numbers"
  },
  {
    name: "Florida",
    code: "FL",
    pattern: "^[A-Za-z]{1}[0-9]{12}$",
    tooltip: "1 letter + 12 numbers"
  },
  {
    name: "Georgia",
    code: "GA",
    pattern: "^[0-9]{7,9}$",
    tooltip: "7-9 numbers"
  },
  {
    name: "Guam",
    code: "GU",
    pattern: "^[A-Za-z]{1}[0-9]{14}$",
    tooltip: "1 letter + 14 numbers"
  },
  {
    name: "Unknown",
    code: "GV",
    pattern: "^[0-9A-Za-z]{1,20}$",
    tooltip: "up to 20 letters or numbers"
  },
  {
    name: "Hawaii",
    code: "HI",
    pattern: "(^[A-Za-z]{1}[0-9]{8}$)|(^[0-9]{9}$)",
    tooltip: "1 letter + 8 numbers, or 9 numbers"
  },
  {
    name: "Idaho",
    code: "ID",
    pattern: "(^[A-Za-z]{2}[0-9]{6}[A-Za-z]{1}$)|(^[0-9]{9}$)",
    tooltip: "2 letters + 6 numbers + 1 letter, or 9 numbers"
  },
  {
    name: "Illinois",
    code: "IL",
    pattern: "^[A-Za-z]{1}[0-9]{11,12}$|^[0-9]{11}[A-Za-z]{1}$",
    tooltip: "1 letter + 11-12 numbers, or 11 numbers + 1 letter"
  },
  {
    name: "Indiana",
    code: "IN",
    pattern: "(^[A-Za-z]{1}[0-9]{9}$)|(^[0-9]{9,10}$)",
    tooltip: "1 letter + 9 numbers, or 9-10 numbers"
  },
  {
    name: "Iowa",
    code: "IA",
    pattern: "^([0-9]{9}|([0-9]{3}[A-Za-z]{2}[0-9]{4}))$",
    tooltip: "9 numbers, or 3 numbers + 2 letters + 4 numbers"
  },
  {
    name: "Kansas",
    code: "KS",
    pattern: "(^([A-Za-z]{1}[0-9]{1}){2}[A-Za-z]{1}$)|(^[A-Za-z]{1}[0-9]{8}$)|(^[0-9]{9}$)",
    tooltip: "1 letter + 1 number + 1 letter + 1 number + 1 letter, 1 letter + 8 numbers, or 9 numbers"
  },
  {
    name: "Kentucky",
    code: "KY",
    pattern: "(^[A-Za-z]{1}[0-9]{8,9}$)|(^[0-9]{9}$)",
    tooltip: "1 letter + 8-9 numbers, or 9 numbers"
  },
  {
    name: "Louisiana",
    code: "LA",
    pattern: "^[0-9]{1,9}$",
    tooltip: "1-9 numbers"
  },
  {
    name: "Maine",
    code: "ME",
    pattern: "(^[0-9]{7}$)|(^[0-9]{7}[A-Za-z]{1}$)",
    tooltip: "7 numbers, or 7 numbers + 1 letter"
  },
  {
    name: "Maryland",
    code: "MD",
    pattern: "(^[A-Za-z]{1}[0-9]{12}$)|(^[mM][dD][0-9]{11,13}$)",
    tooltip: "1 letter + 12 numbers or MD + 11-13 numbers"
  },
  {
    name: "Massachusetts",
    code: "MA",
    pattern: "(^[A-Za-z]{2}[0-9]{7}$)|(^[A-Za-z]{1}[0-9]{8}$)|(^[0-9]{9}$)",
    tooltip: "2 letters + 7 numbers, or 1 letter + 8 numbers, or 9 numbers"
  },
  {
    name: "Michigan",
    code: "MI",
    pattern: "(^[A-Za-z]{1}[0-9]{10}$)|(^[A-Za-z]{1}[0-9]{12}$)",
    tooltip: "1 letter + 10 numbers, or 1 letter + 12 numbers"
  },
  {
    name: "Minnesota",
    code: "MN",
    pattern: "^[A-Za-z]{1}[0-9]{12}$",
    tooltip: "1 letter + 12 numbers"
  },
  {
    name: "Mississippi",
    code: "MS",
    pattern: "^[0-9]{9}$",
    tooltip: "9 numbers"
  },
  {
    name: "Missouri",
    code: "MO",
    pattern: "(^[0-9]{3}[A-Z]{1}[0-9]{6}$)|(^[A-Z]{1}[0-9]{5,9}$)|(^[A-Z]{1}[0-9]{6}[R]{1}$)|(^[0-9]{8}[A-Z]{2}$)|(^[0-9]{9}[A-Z]{1}$)|(^[0-9]{9}$)",
    tooltip: "3 numbers + 1 letter + 6 numbers, 1 letter + 5-9 numbers, or 1 letter + 6 numbers + R, or 8 numbers + 2 letters, or 9 numbers + 1 letter, or 9 numbers"
  },
  {
    name: "Montana",
    code: "MT",
    pattern: "(^[A-Za-z]{1}[0-9]{8}$)|(^[A-Za-z]{3}[0-9]{10}$)|(^[0-9]{13}$)|(^[0-9]{9}$)|(^[0-9]{14}$)",
    tooltip: "1 letter + 8 numbers, 13 numbers, 9 numbers, or 14 numbers"
  },
  {
    name: "Nebraska",
    code: "NE",
    pattern: "^[0-9]{1,7}|[A-Za-z]{1}[0-9]{6,8}$",
    tooltip: "1-7 numbers, or 1 letter + 6-8 numbers"
  },
  {
    name: "Nevada",
    code: "NV",
    pattern: "(^[0-9]{9,10}$)|(^[0-9]{12}$)|(^[Xx]{1}[0-9]{8}$)",
    tooltip: "9-10 numbers, or 12 numbers, or X + 8 numbers"
  },
  {
    name: "New Hampshire",
    code: "NH",
    pattern: "(^[0-9]{2}[A-Za-z]{3}[0-9]{5}$)|(^[A-Za-z]{3}[0-9]{8}$)",
    tooltip: "2 numbers + 3 letters + 5 numbers, or 3 letters + 8 numbers"
  },
  {
    name: "New Jersey",
    code: "NJ",
    pattern: "^[A-Za-z]{1}[0-9]{14}$",
    tooltip: "1 letter + 14 numbers"
  },
  {
    name: "New Mexico",
    code: "NM",
    pattern: "^[0-9]{8,9}$",
    tooltip: "8-9 numbers"
  },
  {
    name: "New York",
    code: "NY",
    pattern: "(^[A-Za-z]{1}[0-9]{7}$)|(^[A-Za-z]{1}[0-9]{18}$)|(^[0-9]{8,9}$)|(^[0-9]{16}$)|(^[A-Za-z]{8}$)",
    tooltip: "1 letter + 7 numbers, or 1 letter + 18 numbers, or 8-9 numbers, or 16 numbers, or 8 letters"
  },
  {
    name: "North Carolina",
    code: "NC",
    pattern: "^[0-9]{1,12}$",
    tooltip: "1-12 numbers"
  },
  {
    name: "North Dakota",
    code: "ND",
    pattern: "(^[A-Za-z]{3}[0-9]{6}$)|(^[0-9]{9}$)",
    tooltip: "3 letters + 6 numbers, or 9 numbers"
  },
  {
    name: "Ohio",
    code: "OH",
    pattern: "(^[A-Za-z]{1}[0-9]{4,8}$)|(^[A-Za-z]{2}[0-9]{3,7}$)|(^[0-9]{8}$)",
    tooltip: "1 letter + 4-8 numbers, or 2 letters + 3-7 numbers, or 8 numbers"
  },
  {
    name: "Oklahoma",
    code: "OK",
    pattern: "(^[A-Za-z]{1}[0-9]{9}$)|(^[0-9]{9}$)",
    tooltip: "1 letter + 9 numbers, or 9 numbers"
  },
  {
    name: "Oregon",
    code: "OR",
    pattern: "(^[0-9]{5,9}$)|(^[A-Za-z]{1}[0-9]{6,7}$)",
    tooltip: "5-9 numbers, or 1 letter + 6-7 numbers"
  },
  {
    name: "Pennsylvania",
    code: "PA",
    pattern: "^[0-9]{8}$",
    tooltip: "8 numbers"
  },
  {
    name: "Puerto Rico",
    code: "PR",
    pattern: "(^[0-9]{9}$)|(^[0-9]{5,7}$)",
    tooltip: "5-7 numbers or 9 numbers"
  },
  {
    name: "Rhode Island",
    code: "RI",
    pattern: "^([0-9]{7}$)|(^[A-Za-z]{1}[0-9]{6}$)",
    tooltip: "7 numbers, or 1 letter + 6 numbers"
  },
  {
    name: "South Carolina",
    code: "SC",
    pattern: "^[0-9]{5,11}$",
    tooltip: "5-11 numbers"
  },
  {
    name: "South Dakota",
    code: "SD",
    pattern: "(^[0-9]{6,10}$)|(^[0-9]{12}$)",
    tooltip: "6-10 numbers, or 12 numbers"
  },
  {
    name: "Tennessee",
    code: "TN",
    pattern: "^[0-9]{7,9}$",
    tooltip: "7-9 numbers"
  },
  {
    name: "Texas",
    code: "TX",
    pattern: "^[0-9]{7,8}$",
    tooltip: "7-8 numbers"
  },
  {
    name: "Utah",
    code: "UT",
    pattern: "^[0-9]{4,10}$",
    tooltip: "4-10 numbers"
  },
  {
    name: "Vermont",
    code: "VT",
    pattern: "(^[0-9]{8}$)|(^[0-9]{7}[A]$)",
    tooltip: "8 numbers, or 7 numbers + A"
  },
  {
    name: "Virginia",
    code: "VA",
    pattern: "(^[A-Za-z]{1}[0-9]{8,11}$)|(^[0-9]{9}$)",
    tooltip: "1 letter + 8 numbers, 1 letter + 9 numbers, 1 letter + 10 numbers, 1 letter + 11 numbers, or 9 numbers"
  },
  {
    name: "Washington",
    code: "WA",
    pattern: "^(?=.{12}$)[A-Za-z]{1,7}[A-Za-z0-9\\*]{4,11}$",
    tooltip: "1-7 letters + any combination of letters, numbers, and * for a total of 12 characters"
  },
  {
    name: "West Virginia",
    code: "WV",
    pattern: "(^[0-9]{7}$)|(^[A-Za-z]{1,2}[0-9]{5,6}$)",
    tooltip: "7 numbers, or 1-2 letters + 5-6 numbers"
  },
  {
    name: "Wisconsin",
    code: "WI",
    pattern: "^[A-Za-z]{1}[0-9]{13}$",
    tooltip: "1 letter + 13 numbers"
  },
  {
    name: "Wyoming",
    code: "WY",
    pattern: "^[0-9]{9,10}$",
    tooltip: "9-10 numbers"
  }
];